import type { IndicacoesAmigosModel } from "../models/indicacoesAmigosModel"
import { IndicacoesAmigosActionsTypes } from "./indicacoesAmigosActions"
import type { IndicacoesAmigosActions } from "./indicacoesAmigosActions"

export function indicacoesAmigosReducer(
    state: IndicacoesAmigosModel,
    action: IndicacoesAmigosActions
): IndicacoesAmigosModel {
    switch (action.type) {
        case IndicacoesAmigosActionsTypes.CARREGAR:
            return { ...state, indicacoes: action.payload }
        default:
            return state
    }
}
